if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('.product-content__panel')];
      if (!tabs.length || tabs.length !== panels.length) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
      this.dataset.ready = 'true';
      this.querySelector('[role="tablist"]').hidden = false;
    }
  });
}
